var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('body',{class:[
    'App',
    ("-" + (_vm.decomoji.size || 'll')),
    {
      '-created': _vm.decomoji.created,
      '-dark': _vm.decomoji.dark,
      '-reacted': _vm.decomoji.reacted,
      '-updated': _vm.decomoji.updated,
      '-vertical': _vm.decomoji.vertical,
    } ]},[_c('RouterView')],1)}
var staticRenderFns = []

export { render, staticRenderFns }